export const replaceNull = <V>(_: string, value: V): V | undefined =>
  String(value) === "null" ? undefined : value;
